<template>
  <div class="page">
    <TipsHbrb ref="child"></TipsHbrb>
    <PageLoading v-if="loading"></PageLoading>
    <div class="topBanner">
      <img src="@/assets/images/blind/topImg.png" alt="">
    </div>
    <div class="openBlind" @click="toCate">
      <img src="@/assets/images/blind/openBlind.png" alt="">
    </div>
    <div class="moreBtn" @click="showPageLink">更多资讯</div>
    <div class="actNote" @click="showNoticePup">活动说明</div>
    <!-- <div class="timebox">活动时间：4月5日-20日</div> -->
    <div class="runbg"></div>
    <div class="runbg run2"></div>
    <div class="wordB">
      <word-3D ref="word3D" :fontScale="1.5" :speed="1.2"/>
    </div>

    <!-- 活动规则 -->
    <van-popup v-model="showCate" class="catePopBox" closeable close-icon="close" round>          
      <div class="btnBox">      
        <div class="btn" v-for="(cate, index) in prizeCateList" :key="index" @click="toLucky(cate)">
          <div class="left"></div>
          <div class="txt">{{cate.cname}}</div>
          <div class="right"></div>
        </div>

        <!-- <div class="btn" @click="toLucky">
          <div class="left"></div>
          <div class="txt">秦皇岛</div>
          <div class="right"></div>
        </div> -->
      </div>
    </van-popup>

    <!-- 活动规则 -->
    <van-popup v-model="showNotice" closeable close-icon="close" round>          
      <div class="noticBox">        
        <h2 class="noticTitle">
          <span class="line"></span>
          <span class="text">活动说明</span>
          <span class="line"></span>
        </h2>
        <div class="noticTxt" v-html="this.actExtend.explain"></div>
      </div>
    </van-popup>
    <navBar></navBar>
    <!-- 1电脑端，2微信端，3纵览新闻客户端，4河北日报客户端，5H5端 -->
    <stat :actId="actInfo.lotteryid" :actTitle="actInfo.title" :from="4" v-if="actInfo && actInfo.lotteryid"></stat>
  </div>
</template>

<script>

//纵览顶部提示栏及唤起app
import TipsHbrb from '@/components/TipsHbrb.vue'
import PageLoading from '@/components/PageLoading.vue'
import Word3D from '@/components/wordCloud3D'
import navBar from '@/components/navBar.vue'
import stat from '@/components/stat.vue'
import {reqWxAuthorize} from '@/api/index.js'
import {reqLotteryInfo, reqLotteryExtend, reqLink} from '@/api/lotteryHbrb.js'
import Cookies from 'js-cookie'
import {isWeixin,wxAuthorize, removeQueryParam} from "@/utils/wx-authorize.js" //微信授权
//分享
import { wxShare } from '@/utils/wxshare-wes2.com.js'
import { Dialog } from 'vant';
export default {
  name: 'index',
  components: {
    TipsHbrb, PageLoading, Word3D, navBar, stat
  },
  data () {
    return {
      loading: true,
      lotteryid:0,
      token:"",
      accessid:'', 
      openid:'', //微信用户openid   
      accountId: '',
      uniqueId: '',
      title:"",       
      actInfo:{},   
      actExtend:{},
      prizeCateList:[],
      prizeList:[],
      showNotice:false,
      shareImg:"https://img2.hebnews.cn/img/home.53fe0d7.png",
      shareTitle:"",
      shareDesc:"", 
      currDis:0,
      showCate:false,
      showOpen:false,
      wordData:[]
    }
  },  
  created (){
      let lotteryid = this.$route.query.lotteryid;
      if(lotteryid) {
        this.lotteryid = lotteryid;
        this.actInit();  //加载活动信息
        // this.getLuckList();
        this.link();
      } 
  },
  mounted () {
    
    if(this.lotteryid) {
      let accountId = this.$store.state.accountId;
      let uniqueId = this.$store.state.uniqueId;
      if(accountId && uniqueId){
        this.accountId = accountId;
        this.uniqueId = uniqueId;
      }else{
         if (process.env.NODE_ENV === 'development') {
              // 指定用户登录测试 begin
              let accountId = '6358b3c89f78a023d2b4efcc';
              let uniqueId = '6a7536ef6e32214051043dd1';
              this.accountId = accountId;
              this.uniqueId = uniqueId;
              this.$store.commit("SET_ACCOUNTID",accountId);
              this.$store.commit("SET_UNIQUEID",uniqueId);             
              // 指定用户登录测试 end
          } else if (process.env.NODE_ENV === 'production') {
              // 生产环境
              console.log('production');
              this.cpLoad(true)  //日报客户端js-sdk加载并初始化

          }
      }
    } else {
      this.$toast({
        icon: 'warning-o',
        message: '活动不存在'
      });
    }
  },  
  computed: {},
  methods: {
    cpLoad(runAll) {
      let _this = this; 
      let cpMain = function() {        
          let is_login = false;
          CP.getDeviceInfo({
              completed: function(data){
                  CP.tools.writelog('get_device_info', data);                   
                  console.log('hbrb_version',data.version);
              },
              cpIncompatible: function () {
                  CP.tools.writelog('CP.getDeviceInfo', '此环境不支持此方法');
                  Dialog.confirm({
                    title: '消息提示',
                    message: '请登录客户端后参与活动',
                  }).then(() => {
                    if (/(hbxw)/i.test(navigator.userAgent)) {
                      _this.cpLoad(false);
                    } else {
                      _this.$refs.child.toLink();
                    }
                  }).catch(() => {
                    // on cancel
                  });
              }
          });
          //自身的业务代码，以下为调用样例
          CP.isLogin({  //判断是否登录的接口，
            completed: function(data){
            CP.tools.writelog('get_is_login', data);			
            if(data.is_login==1) {
              is_login=true;					
              //获取unique_id
              CP.getUniqueId({
                completed: function(data){
                  console.log('data.unique_id',data.unique_id);
                  _this.$store.commit("SET_UNIQUEID",data.unique_id);
                  _this.uniqueId = data.unique_id;
                  //获取account_id
                  CP.getAccountId({
                    completed: function(data){
                      console.log('data.account_id',data.account_id);
                      _this.$store.commit("SET_ACCOUNTID",data.account_id);
                      _this.accountId = data.account_id;
                      _this.loginInit();
                    },
                    cpIncompatible: function () {
                      CP.tools.writelog('CP.getAccountId', '此环境不支持此方法');
                    }
                  });
                },
                cpIncompatible: function () {
                  CP.tools.writelog('CP.getUniqueId', '此环境不支持此方法');
                }
              });
            } else {
              //调用用户登录窗口
              CP.showLogin({
                completed: function(data){
                  console.log('show_login data',data);
                  if(data.is_login==1) {
                    console.log(data.account_id);
                    _this.$store.commit("SET_UNIQUEID",data.unique_id);
                    _this.$store.commit("SET_ACCOUNTID",data.account_id);
                    _this.uniqueId = data.unique_id;
                    _this.accountId = data.account_id;
                    _this.loginInit();
                  }
                  CP.tools.writelog('show_login', data);
                },
                cpIncompatible: function () {
                  CP.tools.writelog('CP.showLogin', '此环境不支持此方法');
                }
              });
            }   
          },
          cpIncompatible: function () {
            CP.tools.writelog('CP.isLogin', '此环境不支持此方法');
          }
          });
      }

      if(runAll) {
        let zjrbCp = document.createElement('script');
        zjrbCp.async = "async";
        zjrbCp.src = 'https://cdn-cp.tmuyun.com/jssdk/v1/zjrb-cp.v1.min.js';
        zjrbCp.charset = "UTF-8";
        document.body.appendChild(zjrbCp);     
        
        // localStorage.setItem('hbrb_account_id', '');
        // localStorage.setItem('hbrb_unique_id', '');

        zjrbCp.onload = function(){
          if(CP && typeof CP.ready === 'function'){
              console.log("CP准备就绪");
              CP.ready({
                debug:false,  //可选，是否是开启调试模式, 默认false
                es6Require: false, //可选，是否需要加载es6库，默认false
                ready:function(client_info){
                  //jssdk加载完成调用此方法
                  console.log('业务逻辑初始化开始');
                  cpMain();// 业务逻辑初始化的main函数
                },
                error: function (error) {
                  console.log('出现错误',error);
                }
              });
          }
        }
      } else {
        cpMain();// 业务逻辑初始化的main函数
      }       
    },
    loginInit(){
      let _this = this; 
      if(this.accountId && this.uniqueId) {

      } else {
        Dialog.confirm({
          title: '消息提示',
          message: '请登录客户端后参与活动',
        })
          .then(() => {
            if (/(hbxw)/i.test(navigator.userAgent)) {
              _this.cpLoad(false);
            } else {
              _this.$refs.child.toLink();
            }
          })
          .catch(() => {
            // on cancel
          });
      } 
    },
    actInit(){
      this.loading = true;
      reqLotteryInfo({lotteryid:this.lotteryid}).then(res => {        
        if(res.code==200) {       
          this.loading = false;   
          this.actInfo = res.data.info;
          document.title = this.actInfo.title;
          this.prizeCateList = res.data.prizeCateList;
   
          this.$store.commit("SET_ACTINFO",res.data.info); 
          this.$store.commit("SET_CATEDATA",res.data.prizeCateList);
          // this.isBgDark = isColorDark(this.actInfo.bgcolor);

          //分享设置
          wxShare({
            title: this.actInfo.share_title,
            desc: this.actInfo.share_desc,
            img: this.actInfo.share_logo
          })
        } else {
          this.loading = false;
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {        
        this.loading = false;
        this.$toast({
            icon: 'warning-o',
            message: err
        });
      }) 
      
    },  
    link(){
      this.loading = true;
      reqLink({lotteryid:this.lotteryid}).then(res => {        
        if(res.code==200) {       
          this.loading = false;   
          console.log('link res', res.data);
          this.wordData = res.data;
          this.$refs.word3D.setTags(this.wordData)  // 数据集
    
        } else {
          this.loading = false;
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {        
        this.loading = false;
        this.$toast({
            icon: 'warning-o',
            message: err
        });
      }) 
      
    },
    switchShow(){
      this.showOpen = !this.showOpen
    },
    showPageLink(){
      window.location.href = "https://hbxw.hebnews.cn/subject.html?id=618726&template=0";      
    },
    showNoticePup() {      
      this.actExtend = this.$store.state.actExtend;
      if(!this.actExtend) {
        this.showNotice = true;
      } else {
        this.loading = true;
        reqLotteryExtend({lotteryid:this.lotteryid}).then(res => {        
          if(res.code==200) {       
            this.loading = false;
            this.actExtend = res.data;   
            this.$store.commit("SET_ACTEXTEND",res.data); 
            this.showNotice = true;
          } else {
            this.loading = false;
            this.$toast({
                icon: 'warning-o',
                message: res.msg
            });
          }
        }).catch(err => {     
          this.loading = false;   
          this.$toast({
              icon: 'warning-o',
              message: err
          });
        }) 
      }
    },
    toCate(){
        this.$router.push({ path: '/cate',query:{...this.$route.query} })
    },
    setCurr(curr){
      this.currDis = (curr==0) ? 0 :1
    },
    openBox(index) {
      if (this.activeBox === index) {
        this.activeBox = -1
        void this.$el.offsetHeight // 强制回流，重置动画
        this.activeBox = index
        return
      }
      this.activeBox = index
    },

  }
  
}
</script>

<style>
  @media screen and (min-width: 1200px) {
    html,body { 
      display: flex; 
      justify-content: center; 
      font-size: 190px!important;
      overflow-x: hidden;
      width: 100%;
    }
  }
  .van-toast{
    width: 240px;
  }
</style>
<style lang="scss" scoped>
@import '@/assets/css/index.scss';
</style>